import { OperationType } from '@aavaz-ai/eql-parser-ts/dist/types';
import {
  useGetQuantifyDuration,
  useGetQuantifyWhereClause,
} from '@modules/quantify/hooks';
import { TimeUnit } from 'generated/graphql';
import { TimeRange } from 'v2/core/entities';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import { useQuantifyStore } from '../store/quantifyStore';
import { getHasMetadataFilterForEqlField } from '../utils';

interface GetQueryContainerForAllFiltersApplied {
  shouldIncludeDashboardFilters?: boolean;
  shouldCombineWithMetadataFilter?: boolean;
}

export const useGetQueryContainerForAllFiltersApplied = ({
  shouldIncludeDashboardFilters = true,
  shouldCombineWithMetadataFilter = true,
}: GetQueryContainerForAllFiltersApplied = {}) => {
  const whereClause = useGetQuantifyWhereClause({
    shouldIncludeDashboardFilters,
  });
  const groupBy = useQuantifyStore(({ query }) => query.groupByField);
  const duration = useGetQuantifyDuration();

  const metadataFilter = getHasMetadataFilterForEqlField(groupBy);

  const queryWhereClause = (() => {
    if (shouldCombineWithMetadataFilter && metadataFilter) {
      return combineWhereClauses(
        whereClause,
        metadataFilter,
        OperationType.AND,
      );
    }

    return whereClause;
  })();

  const queryContainer = {
    AggregatePeriod: TimeUnit.Week,
    DateRange: duration as TimeRange,
    WhereClause: queryWhereClause,
  };

  return queryContainer;
};
